import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { type TypographyVariantProps, typography } from '@repo/pandacss/recipes';
import type { JsxStyleProps, SystemStyleObject } from '@repo/pandacss/types';
import type { ElementType, HTMLAttributes, Ref } from 'react';
export type TypographyPropsBag = {
  variant?: TypographyVariantProps['variant'];
  css?: SystemStyleObject;
  className?: string;
  [key: string]: unknown;
};
type TypographyProps = TypographyVariantProps & HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  css?: JsxStyleProps['css'];
  ref?: Ref<HTMLElement>;
};
export function Typography(t0) {
  const $ = _c(16);
  let className;
  let cssProp;
  let props;
  let ref;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as: t1,
      variant: t2,
      css: cssProp,
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = cssProp;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
    $[6] = t2;
  } else {
    className = $[1];
    cssProp = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const Component = t1 === undefined ? "p" : t1;
  const variant = t2 === undefined ? "body" : t2;
  const t3 = ref as Ref<HTMLParagraphElement & HTMLSpanElement & HTMLHeadingElement>;
  let t4;
  if ($[7] !== className || $[8] !== cssProp || $[9] !== variant) {
    t4 = cx(typography({
      variant
    }), css(cssProp), className);
    $[7] = className;
    $[8] = cssProp;
    $[9] = variant;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== Component || $[12] !== props || $[13] !== t3 || $[14] !== t4) {
    t5 = <Component ref={t3} className={t4} {...props} />;
    $[11] = Component;
    $[12] = props;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}